import React from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { useNavigate } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import { useAlert } from '@lwtears/lwt-common-frontend/lib/Alert';
import { translate } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';

const TopBar: React.FC<React.PropsWithChildren> = () => {
  const classes = useStyles();
  const [, { closeAlert }] = useAlert();
  const navigate = useNavigate();
  const t = (key) => translate('ui', key);
  const homeAction = () => {
    closeAlert();
    navigate('/home', { replace: true });
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" className={classes.root}>
        <div className={classes.leftIcons}>
          <IconButton
            onClick={homeAction}
            className={classes.homeButton}
            color="inherit"
            aria-label={t('buttons.home')}
            size="large"
          >
            <HomeIcon className={classes.homeIcon} />
          </IconButton>
          <Divider orientation="vertical" flexItem />
          <Typography variant="h3" className={classes.title}>
            {t('nav.assessments')}
          </Typography>
        </div>
        <div className={classes.rightIcons}>
          <Link className={classes.navLink} to="/educatorPackets">
            {t('nav.adminPackets')}
          </Link>
          <Link className={classes.navLink} to="/help">
            {t('nav.help')}
          </Link>
        </div>
      </AppBar>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiPaper-root': {
      top: 0,
      position: 'sticky',
      zIndex: 99,
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  leftIcons: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  homeIcon: {
    width: '2rem',
    height: '2rem',
  },
  homeButton: {
    padding: theme.spacing(4),
  },
  rightIcons: {
    display: 'inline-flex',
    alignItems: 'center',
  },
  navLink: {
    padding: theme.spacing(4),
    color: 'white',
    textDecoration: 'none',
    fontFamily: 'HWT Futura',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  title: {
    marginLeft: theme.spacing(4),
  },
}));

export default TopBar;
